const DEFAULT_CONFIRM = "Are you sure?"

function methodOf(form) {
  const override = form.querySelector('input[name="_method"]')?.value
  return (override || form.getAttribute("method") || "get").toLowerCase()
}

function applyDestroyConfirms() {
  document.querySelectorAll("form").forEach((form) => {
    if (form.dataset.skipConfirm === "true") return
    if (form.hasAttribute("data-turbo-confirm")) return
    if (form.querySelector("[data-turbo-confirm]")) return
    if (methodOf(form) === "delete") {
      form.setAttribute("data-turbo-confirm", DEFAULT_CONFIRM)
    }
  })

  document.querySelectorAll("a[data-turbo-method='delete']").forEach((link) => {
    if (link.dataset.skipConfirm === "true") return
    if (link.hasAttribute("data-turbo-confirm")) return
    link.setAttribute("data-turbo-confirm", DEFAULT_CONFIRM)
  })
}

document.addEventListener("DOMContentLoaded", applyDestroyConfirms)
document.addEventListener("turbo:load", applyDestroyConfirms)
document.addEventListener("turbo:render", applyDestroyConfirms)
document.addEventListener("turbo:frame-render", applyDestroyConfirms)
